// extracted by mini-css-extract-plugin
module.exports = {"root":"PhoneNumbers_root___JIiS","disabled":"PhoneNumbers_disabled__HECFt","spinner":"PhoneNumbers_spinner__gfgOM"};